/**
 * 出発時刻のレンジスライダーに設定できる最大値最小値
 */
export const DEPARTURE_TIME_POSSIBLE_VALUES = {
  max: 1439,
  min: 0,
};
